import { z } from "zod";

import { authErrorCodeSchema } from "@/lib/auth-error-codes";

// The browser seam for the login page's search params. The `?error=`
// vocabulary itself is not here — it is shared by both graphs, so it lives in
// `@/lib/auth-error-codes`; this file describes only what the login *route*
// parses out of its URL.
//
// Zod v4 implements Standard Schema, so this passes straight into the login
// route's `validateSearch`. `.catch(undefined)` drops malformed params
// instead of failing navigation.
export const loginSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
  error: authErrorCodeSchema.optional().catch(undefined),
});

export type LoginSearch = z.infer<typeof loginSearchSchema>;
